import { useEffect } from "react";

function useAutoFocus(inputRef) {
    const callAutoFocus = (el) => {
        el.focus()
    }
    useEffect(() => {
        if (inputRef.current) {
            callAutoFocus(inputRef.current)
        }
    }, [])

    return callAutoFocus
}

export default useAutoFocus;
